import { Box, Checkbox, FormControlLabel, Typography } from '@mui/material';

import { Section, SectionCard, SectionHeader } from '@/components/common';
import { RichTextReadOnly } from '@/components/common/RichTextEditor/RichTextReadOnly';
import type { AppraisalDetailResponse } from '@/api/types/appraisal.types';

interface StaffingTcNotesSectionProps {
  appraisalDetail: AppraisalDetailResponse;
}

export function StaffingTcNotesSection({ appraisalDetail }: StaffingTcNotesSectionProps) {
  return (
    <Section>
      <SectionHeader>CONFIDENTIAL - STAFFING TALENT COMMITTEE NOTES</SectionHeader>

      <SectionCard>
        <RichTextReadOnly content={appraisalDetail.confidentialStaffingTcNotes ?? ''} />

        <Box sx={{ mt: 3 }}>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
            TC Actions
          </Typography>
          <Box sx={{ display: 'flex', gap: 3, flexWrap: 'wrap' }}>
            {/* #1095: PMI Required moved to the Collator's Proposed Actions (Notes to TC). */}
            <FormControlLabel
              control={
                <Checkbox
                  checked={appraisalDetail.activeCoaching}
                  disabled
                  inputProps={{ 'aria-label': 'Active Coaching' }}
                />
              }
              label="Active Coaching"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={appraisalDetail.ldIntervention}
                  disabled
                  inputProps={{ 'aria-label': 'L&D Intervention' }}
                />
              }
              label="L&D Intervention"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={appraisalDetail.pip}
                  disabled
                  inputProps={{ 'aria-label': 'PIP' }}
                />
              }
              label="PIP"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={appraisalDetail.tcCheckIn}
                  disabled
                  inputProps={{ 'aria-label': 'Check-in' }}
                />
              }
              label="Check-in"
            />
          </Box>
        </Box>
      </SectionCard>
    </Section>
  );
}
